module.exports = __webpack_public_path__ + "static/media/Prem.eae76c0e.jpeg";